import { render, staticRenderFns } from "./SettingUnit.vue?vue&type=template&id=f6c2a918&scoped=true"
import script from "./SettingUnit.vue?vue&type=script&lang=js"
export * from "./SettingUnit.vue?vue&type=script&lang=js"
import style0 from "./SettingUnit.vue?vue&type=style&index=0&id=f6c2a918&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c2a918",
  null
  
)

export default component.exports